import DetailCopyFollowersPanelField from './fields/Detail/CopyFollowersPanelField.vue'

const copyFollowersPanelFieldSetup = (app) => {
  app.component('detail-copy-followers-panel-field', DetailCopyFollowersPanelField)
  app.component('form-copy-followers-panel-field', { render: () => null })
  app.component('index-copy-followers-panel-field', { render: () => null })
}

export { copyFollowersPanelFieldSetup }
